export default __webpack_public_path__ + "static/media/img-maintenance.297dab55.png";